<nav class="navbar navbar-expand-lg navbar-light custom-nav">
  <a class="navbar-brand"><img src="../../../assets/img/Logo resized.svg" width="111px"></a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarNavDropdown">
    <ul class="navbar-nav ml-auto">
      <li class="nav-item dropdown border-left-2px">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="fa fa-user avatar"></i><span>{{userDetailService.current_user()?.name | ucwords}}</span>
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
          <a class="dropdown-item cursor-pointer" [routerLink]="['customer/change-password/'+userDetailService.current_user()?.email]" routerLinkActive = "active">Change Password</a>
          <a class="dropdown-item cursor-pointer" [routerLink]="['customer/view-profile/'+userDetailService.current_user()?.id]" routerLinkActive="active">View Details</a>
          <a class="dropdown-item cursor-pointer " (click) = "logOut()">Logout</a>
        </div>
      </li>
    </ul>
  </div>
</nav>



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/shared/customer-header/customer-header.component.html